import type { CaptureResult, PostHogConfig } from "posthog-js";

export interface PostHogSetup {
  apiKey: string;
  options: Partial<PostHogConfig>;
}

export function getPostHogConfig(): PostHogSetup | undefined {
  if (import.meta.env.VITE_DISABLE_POSTHOG) {
    return;
  }

  if (!window.POSTHOG_KEY || !window.POSTHOG_HOST) {
    console.error("No PostHog key set, PostHog will be disabled");

    return;
  }

  return {
    options: {
      api_host: window.POSTHOG_HOST,
      person_profiles: "identified_only",
      autocapture: false,
      before_send: onBeforeSendEvent,
    },
    apiKey: window.POSTHOG_KEY,
  };
}

function onBeforeSendEvent(event: CaptureResult | null) {
  if (!event) return null;

  // Add here any additional "super attributes" across all captured events
  return {
    ...event,
    device_language_id: window.navigator.language.split("-")[0],
  };
}
